import { render, staticRenderFns } from "./GlobalSpecsFormPriceCells.vue?vue&type=template&id=0c306254&"
import script from "./GlobalSpecsFormPriceCells.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsFormPriceCells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports